module.exports = __webpack_public_path__ + "img/black-overflow-menu.c98052b9.svg";